module.exports = __webpack_public_path__ + "img/rubi.69c70945.png";